import { render, staticRenderFns } from "./proposal-25-video-advertising.vue?vue&type=template&id=50cf0289"
import script from "./proposal-25-video-advertising.vue?vue&type=script&lang=js"
export * from "./proposal-25-video-advertising.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports